if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
      
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
      
        this.handleErrorMessage();
      
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');
      
        const formData = new FormData(this.form);
        const productId = formData.get('id'); // Get product variant ID
        // const quantityToAdd = parseInt(formData.get('quantity') || '1', 10);
      
        // Check if the product is a "Seed" product
        const isSeedProduct = this.submitButton.getAttribute('data-seed') === 'true';
        let totalSeeds = 0;

        // Fetch current cart details
        if(isSeedProduct){
          fetch('/?section_id=cart-products-details', { method: 'GET' })
            .then((response) => response.text())
            .then((html) => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, 'text/html');
              const jsonData = doc.querySelector('#shopify-section-cart-products-details').textContent.trim();
              const parsedData = JSON.parse(jsonData);
              totalSeeds = parsedData.totalSeeds;
              if(totalSeeds < 10){
                this.addProductToCart(formData, totalSeeds);
                let qtyInput = document.querySelector('.product__info-wrapper .quantity__input');
                qtyInput.value = 1;
              }else{
                this.handleErrorMessage('Du kan maksimalt vælge 10 i alt');
                this.submitButton.classList.remove('loading');
                this.querySelector('.loading__spinner').classList.add('hidden');
                this.submitButton.removeAttribute('aria-disabled');
              }
            });
        }else{
          this.addProductToCart(formData);
        }
        
      }
      
      // Helper function to add product to cart
      addProductToCart(formData) {
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = formData;
      
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.message || 'Error adding to cart.');
              this.submitButton.classList.remove('loading');
              this.submitButton.removeAttribute('aria-disabled');
              return;
            }else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }
      
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: response,
            });
      
            // Render cart updates
            this.cart.renderContents(response);
          })
          .catch((error) => {
            console.error('Error adding product to cart:', error);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            this.querySelector('.loading__spinner').classList.add('hidden');
            this.submitButton.removeAttribute('aria-disabled');
          });
      }




      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
